export const isAnonymousAuthUser = (user) =>
  Boolean(user?.uid && user?.isAnonymous === true);

export const isCanonicalAuthUser = (user) =>
  Boolean(user?.uid && user?.isAnonymous !== true);

export const getCanonicalAuthUserId = (user) =>
  isCanonicalAuthUser(user) ? String(user.uid) : "";
